<script lang="ts" setup>
import type { IProps } from './UiPrizes.types'

defineProps<IProps>()
</script>

<template>
  <section class="prizes">
    <div class="prizes__container">
      <h2 class="prizes__header">
        {{ header }}
      </h2>

      <div class="prizes__wrapper">
        <div class="prizes__column-left">
          <picture class="prizes__picture">
            <source
              v-if="img.srcMobile"
              media="(max-width: 767px)"
              :srcset="img.srcMobile"
            >
            <img
              class="prizes__img"
              :alt="img.alt"
              :src="img.src"
            >
          </picture>
        </div>

        <div class="prizes__column-right">
          <div
            v-for="(text, index) in texts"
            :key="text.text"
            :class="['prizes__text', `${index === 0 ? 'prizes__text--first' : ''}`]"
          >
            <div class="prizes__square">
              <div class="prizes__dot" />
            </div>

            <div class="prizes__content">
              <p class="prizes__text-top">
                {{ text.text }}
              </p>

              <p class="prizes__text-bottom">
                {{ text.subtext }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.prizes {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 0 2rem;

  &__container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 4rem 2rem;
    background-color: $gray-100;
    border-radius: 2rem;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 4rem;
    max-width: 143rem;
    width: 100%;
  }

  &__column-left {
    display: flex;
    justify-content: center;
  }

  &__picture {
    display: contents;
  }

  &__img {
    max-width: 40rem;
    width: 100%;
  }

  &__header {
    @include h8;
    margin-bottom: 3.2rem;
    color: $text-400;
    text-align: center;
  }

  &__subheader {
    @include h9;
    margin-bottom: 2.4rem;
  }

  &__text {
    display: flex;

    &--first {
      margin-bottom: 4.8rem;
    }
  }

  &__square {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3.2rem;
    height: 3.2rem;
    margin-right: 2.4rem;
    background-color: $purple-50;
    border-radius: 0.8rem;
  }

  &__dot {
    width: 0.7rem;
    height: 0.7rem;
    background-color: $purple-400;
    border-radius: 0.3rem;
  }

  &__content {
    display: flex;
    flex-direction: column;
    width: calc(100% - 5.6rem);
  }

  &__text-top {
    margin-bottom: 1.6rem;
    @include h9;
    color: $text-400;
  }

  &__text-bottom {
    @include body-1-medium;
    color: $text-400;
  }
}

@include atXS {
  .prizes {

    &__img {
      max-width: 65rem;
    }
  }
}

@include atM {
  .prizes {

    &--white {
      max-width: 162rem;
      margin: 0 auto;
      border-top: 1px solid $gray-300;
    }

    &__container {
      padding: 12rem 0;
    }

    &__wrapper {
      flex-direction: row;
    }

    &__header {
      @include h5;
      margin-bottom: 6.4rem;
    }

    &__img {
      max-width: none;
      width: 72rem;
    }

    &__column-right {
      max-width: 73rem;
      width: calc(100% - 72rem);
      padding-top: 9.5rem;
    }

    &__text-top {
      @include h8;
    }
  }
}
</style>
